import { IconProps } from "@models/types";


export function MenuIconResponsive({className, width, height}: IconProps) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <g id="Group_1135" data-name="Group 1135">
          <path d="M18.88,3.78H1.12A.89.89,0,1,1,1.12,2H18.88a.89.89,0,1,1,0,1.78Z" />
          <path d="M15.33,10.89H1.12a.89.89,0,1,1,0-1.78H15.33a.89.89,0,1,1,0,1.78Z" />
          <path d="M18.88,18H1.12a.89.89,0,0,1,0-1.78H18.88a.89.89,0,0,1,0,1.78Z" />
        </g>
      </svg>
    </>
  );
}
